import { useTranslation } from 'react-i18next'
import { HeroPage } from '@/components/HeroPage'
import { Section } from '@/components/ui/Section'
import { Container } from '@/components/ui/Container'

export function Cookies() {
  const { t, i18n } = useTranslation()
  const lang = i18n.language

  const managementItems = [
    t('cookiePage.management.items.view'),
    t('cookiePage.management.items.blockThirdParty'),
    t('cookiePage.management.items.blockSpecific'),
    t('cookiePage.management.items.blockAll'),
    t('cookiePage.management.items.deleteOnClose'),
  ]

  return (
    <main>
      <HeroPage
        title={t('footer.cookiePolicy')}
        breadcrumb={[{ label: t('footer.cookiePolicy') }]}
      />
      <Section>
        <Container>
          <div className="prose max-w-none">
            <h2 className="text-2xl font-bold text-dark mb-4">
              {t('cookiePage.title')}
            </h2>
            <p className="text-gray-600 mb-4">
              {t('cookiePage.intro')}
            </p>

            <h3 className="text-xl font-semibold text-dark mb-3 mt-6">
              {t('cookiePage.whatAreCookies.title')}
            </h3>
            <p className="text-gray-600 mb-4">
              {t('cookiePage.whatAreCookies.text')}
            </p>

            <h3 className="text-xl font-semibold text-dark mb-3 mt-6">
              {t('cookiePage.types.title')}
            </h3>

            <h4 className="text-lg font-medium text-dark mb-2 mt-4">
              {t('cookiePage.types.technical.title')}
            </h4>
            <p className="text-gray-600 mb-4">
              {t('cookiePage.types.technical.text')}
            </p>

            <h4 className="text-lg font-medium text-dark mb-2 mt-4">
              {t('cookiePage.types.thirdParty.title')}
            </h4>
            <p className="text-gray-600 mb-4">
              {t('cookiePage.types.thirdParty.text')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
              <li>
                <span dangerouslySetInnerHTML={{ __html: t('cookiePage.types.thirdParty.googleMaps') }} />
                {' '}
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                  {t('cookiePage.types.thirdParty.googleMapsLink')}
                </a>.
              </li>
              <li>
                <span dangerouslySetInnerHTML={{ __html: t('cookiePage.types.thirdParty.iubenda') }} />
                {' '}
                <a href="https://www.iubenda.com/privacy-policy" target="_blank" rel="noopener noreferrer" className="text-primary hover:underline">
                  {t('cookiePage.types.thirdParty.iubendaLink')}
                </a>.
              </li>
            </ul>

            <h3 className="text-xl font-semibold text-dark mb-3 mt-6">
              {t('cookiePage.management.title')}
            </h3>
            <p className="text-gray-600 mb-4">
              {t('cookiePage.management.text')}
            </p>
            <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
              {managementItems.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

            <h3 className="text-xl font-semibold text-dark mb-3 mt-6">
              {t('cookiePage.updates.title')}
            </h3>
            <p className="text-gray-600 mb-4">
              {t('cookiePage.updates.text')}
            </p>

            <p className="text-gray-600 mt-8">
              {t('cookiePage.lastUpdate')} {new Date().toLocaleDateString(lang === 'it' ? 'it-IT' : 'en-US')}
            </p>
          </div>
        </Container>
      </Section>
    </main>
  )
}
